import { LOG_OUT } from "../login/action";
import { CLEAR_EUA_AVAILABILITY, SET_EUA_CHECK_AVAILABILITY, SET_EUA_CHECK_AVAILABILITY_ERROR } from "./action";

export const defaultState = {
  euaCheck: null,
  euaError: null,
};

function euaReducer(state = defaultState, action) {
  switch (action.type) {
    case SET_EUA_CHECK_AVAILABILITY:
      return {
        ...state,
        euaCheck: action.payload,
        euaError: null,
      };
    case SET_EUA_CHECK_AVAILABILITY_ERROR:
      return {
        ...state,
        euaCheck: null,
        euaError: action.payload,
      };
    case CLEAR_EUA_AVAILABILITY:
    case LOG_OUT:
      return defaultState;
    default:
      return state;
  }
}

export default euaReducer;
